<template>

  <div>
    <v-toolbar absolute fixed clipped-left height="50px">
      <v-toolbar-title><img style="max-width: 150px; margin-top:5px" src="@/assets/logoStructube.png"></v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat disabled class="hidden-sm-and-down">
          {{email}}
        </v-btn>
        <v-btn to="/home" flat class="hidden-sm-and-down">
          home
        </v-btn>
        <v-btn flat @click="logout">
          logout
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div style="margin-top: 64px">
      <v-layout row pb-3>

          <h2>Welcome {{staffName}}!</h2>

      </v-layout>
      <v-layout row text-left>
        <v-flex xs12 sm6 md4 lg3>

                <BlockList title="Training">
                </BlockList>

          </v-flex>

      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import firebase from 'firebase/app';
import 'firebase/firestore'
import BlockList from "@/components/BlockList";
import { LOGOUT } from "@/store/actions.type";
export default {
  name: "home",
  components: {
    BlockList
  },
  data() {
    return{
      staffName: ""
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }))
        .catch(() => this.$data.snackbar = true);
    }
  },
  mounted: function(){
    firebase.firestore().collection('users').doc(this.userId).get()
    .then((doc) =>{
      if (doc.exists) {

          let data = doc.data()
          this.staffId = data.staffId;
          this.staffName = data.name;

      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }
    }).catch(function(error) {
        console.log("Error getting document:", error);
    });
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
      userId: state => state.auth.user.uid,
      email: state=> state.auth.user.email
    }),

  }
};
</script>
